function isAllowedCodeUrl(codeUrl: string, allowedCodeOrigins: string[]): boolean {
  const url = new URL(codeUrl);

  // Unsupported if the allow list does not include the CDN origin
  return allowedCodeOrigins.includes(url.origin);
}

export function areAllCodeUrlsAllowed(codeUrls: string[], allowedCodeOrigins: string[]): boolean {
  const unsupportedSource = codeUrls.find((containerSourceFile: string) => {
    return !isAllowedCodeUrl(containerSourceFile, allowedCodeOrigins);
  });

  // If there are no unsupported sources, we should load
  return unsupportedSource === undefined;
}
